export const validateBoat = (data) => {
  const errors = {};
  console.log('Validating boat data:', data);

  if (!data.name || data.name.trim() === '') {
    errors.name = 'Name is required';
  } else if (data.name.length > 100) {
    errors.name = 'Name cannot exceed 100 characters';
  }

  if (!data.description || data.description.trim() === '') {
    errors.description = 'Description is required';
  } else if (data.description.length > 1000) {
    errors.description = 'Description cannot exceed 1000 characters';
  }

  let priceValue = null;
  if (data.price && data.price.trim() !== '') {
    priceValue = parseFloat(data.price);
    if (isNaN(priceValue)) {
      errors.price = 'Price must be a valid number';
    } else if (priceValue < 0) {
      errors.price = 'Price cannot be negative';
    }
  }

  if (data.discount_price && data.discount_price.trim() !== '') {
    const discountValue = parseFloat(data.discount_price);
    if (isNaN(discountValue)) {
      errors.discount_price = 'Discount price must be a valid number';
    } else if (discountValue < 0) {
      errors.discount_price = 'Discount price cannot be negative';
    } else if (priceValue !== null && discountValue >= priceValue) {
      errors.discount_price = 'Discount price must be less than regular price';
    }
  }

  if (data.main_image) {
    if (typeof data.main_image !== 'string') {
      const allowedTypes = ['image/jpeg', 'image/png', 'image/webp'];
      if (!allowedTypes.includes(data.main_image.type)) {
        errors.main_image = 'Invalid image format. Allowed formats: JPG, PNG, WEBP';
      }
      if (data.main_image.size > 2 * 1024 * 1024) {
        errors.main_image = 'File size must be less than 2MB';
      }
    }
  }

  const newGalleryFiles = (data.gallery_images || []).filter(img => img instanceof File);
  const allowedGalleryTypes = ['image/jpeg', 'image/png', 'image/webp'];

  newGalleryFiles.forEach((file, index) => {
    if (!allowedGalleryTypes.includes(file.type)) {
      errors[`gallery_images_${index}`] = `Image ${index + 1} has invalid format. Allowed formats: JPG, PNG, WEBP.`;
    }
    if (file.size > 2 * 1024 * 1024) {
      errors[`gallery_images_${index}`] = `Image ${index + 1} must be less than 2MB.`;
    }
  });

  const intFields = [
    { key: 'length', label: 'Length' },
    { key: 'capacity', label: 'Capacity' },
    { key: 'staterooms', label: 'Staterooms' },
    { key: 'bathrooms', label: 'Bathrooms' }
  ];

  intFields.forEach(({ key, label }) => {
    const value = data[key];
    if (value !== undefined && value !== null && value !== '') {
      if (!Number.isInteger(Number(value)) || Number(value) < 0) {
        errors[key] = `${label} must be a non-negative integer`;
      }
    }
  });

  if (data.featured !== undefined && typeof data.featured !== 'boolean') {
    errors.featured = 'Featured must be true or false';
  }

  if (data.note && data.note.trim() !== '') {
    if (data.note.length > 200) {
      errors.note = 'Note cannot exceed 200 characters';
    }
  }

  return errors;
};